// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type MutationOptions, queryOptions } from '@tanstack/angular-query-experimental';

import { client } from '../client.gen';
import { addCodelistEndpoint, assignInstructionEndpoint, cancelInstructionEndpoint, cancelOrderEndpoint, createOrganizationEndpoint, createRoleEndpoint, createTruckEndpoint, createUserEndpoint, createWarehouseEndpoint, deleteTruckEndpoint, deleteUserEndpoint, deleteWarehouseEndpoint, endpoint, getApplicationSettingListEndpoint, getCodelistsEndpoint, getCurrentUserEndpoint, getGridSettingsEndpoint, getLoginApplicationSettingsEndpoint, getOrganizationEmailCategoryStatesEndpoint, getOrganizationEndpoint, getRoleEmailCategoryStatesEndpoint, getRoleEndpoint, getSettingsEndpoint, getTruckEndpoint, getUserEmailPreferencesEndpoint, getUserEndpoint, getUserSettingListEndpoint, getWarehouseEndpoint, healthEndpoint, holdInstructionEndpoint, holdOrderEndpoint, isAuthenticatedEndpoint, listInstructionsEndpoint, listOrdersEndpoint, listOrganizationsEndpoint, listPermissionsEndpoint, listRolesEndpoint, listTrucksEndpoint, listUserEndpoint, listWarehousesEndpoint, loginEndpoint, logoutEndpoint, type Options, organizationCodelistEndpoint, permissionCodelistEndpoint, planOrderEndpoint, readinessEndpoint, resetApplicationSettingsEndpoint, resetUserSettingsEndpoint, roleCodelistEndpoint, saveApplicationSettingsEndpoint, saveGridSettingsEndpoint, saveOrganizationEmailCategoryStatesEndpoint, saveRoleEmailCategoryStatesEndpoint, saveUserEmailPreferencesEndpoint, saveUserSettingsEndpoint, sendSampleEmailEndpoint, setUserLanguageEndpoint, updateOrganizationEndpoint, updateRoleEndpoint, updateTruckEndpoint, updateUserEndpoint, updateWarehouseEndpoint } from '../sdk.gen';
import type { AddCodelistEndpointData, AddCodelistEndpointResponse, AssignInstructionEndpointData, AssignInstructionEndpointResponse, CancelInstructionEndpointData, CancelInstructionEndpointResponse, CancelOrderEndpointData, CancelOrderEndpointResponse, CreateOrganizationEndpointData, CreateOrganizationEndpointResponse, CreateRoleEndpointData, CreateRoleEndpointResponse, CreateTruckEndpointData, CreateTruckEndpointResponse, CreateUserEndpointData, CreateUserEndpointError, CreateUserEndpointResponse, CreateWarehouseEndpointData, CreateWarehouseEndpointResponse, DeleteTruckEndpointData, DeleteTruckEndpointResponse, DeleteUserEndpointData, DeleteUserEndpointResponse, DeleteWarehouseEndpointData, DeleteWarehouseEndpointResponse, EndpointData, EndpointResponse, GetApplicationSettingListEndpointData, GetApplicationSettingListEndpointResponse, GetCodelistsEndpointData, GetCodelistsEndpointResponse, GetCurrentUserEndpointData, GetCurrentUserEndpointResponse, GetGridSettingsEndpointData, GetGridSettingsEndpointResponse, GetLoginApplicationSettingsEndpointData, GetLoginApplicationSettingsEndpointResponse, GetOrganizationEmailCategoryStatesEndpointData, GetOrganizationEmailCategoryStatesEndpointResponse, GetOrganizationEndpointData, GetOrganizationEndpointResponse, GetRoleEmailCategoryStatesEndpointData, GetRoleEmailCategoryStatesEndpointResponse, GetRoleEndpointData, GetRoleEndpointResponse, GetSettingsEndpointData, GetSettingsEndpointResponse, GetTruckEndpointData, GetTruckEndpointResponse, GetUserEmailPreferencesEndpointData, GetUserEmailPreferencesEndpointResponse, GetUserEndpointData, GetUserEndpointResponse, GetUserSettingListEndpointData, GetUserSettingListEndpointResponse, GetWarehouseEndpointData, GetWarehouseEndpointResponse, HealthEndpointData, HealthEndpointResponse, HoldInstructionEndpointData, HoldInstructionEndpointResponse, HoldOrderEndpointData, HoldOrderEndpointResponse, IsAuthenticatedEndpointData, IsAuthenticatedEndpointResponse, ListInstructionsEndpointData, ListInstructionsEndpointResponse, ListOrdersEndpointData, ListOrdersEndpointResponse, ListOrganizationsEndpointData, ListOrganizationsEndpointResponse, ListPermissionsEndpointData, ListPermissionsEndpointResponse, ListRolesEndpointData, ListRolesEndpointResponse, ListTrucksEndpointData, ListTrucksEndpointResponse, ListUserEndpointData, ListUserEndpointResponse, ListWarehousesEndpointData, ListWarehousesEndpointResponse, LoginEndpointData, LoginEndpointError, LoginEndpointResponse, LogoutEndpointData, LogoutEndpointResponse, OrganizationCodelistEndpointData, OrganizationCodelistEndpointResponse, PermissionCodelistEndpointData, PermissionCodelistEndpointResponse, PlanOrderEndpointData, PlanOrderEndpointResponse, ReadinessEndpointData, ReadinessEndpointResponse, ResetApplicationSettingsEndpointData, ResetApplicationSettingsEndpointResponse, ResetUserSettingsEndpointData, ResetUserSettingsEndpointResponse, RoleCodelistEndpointData, RoleCodelistEndpointResponse, SaveApplicationSettingsEndpointData, SaveApplicationSettingsEndpointResponse, SaveGridSettingsEndpointData, SaveGridSettingsEndpointResponse, SaveOrganizationEmailCategoryStatesEndpointData, SaveOrganizationEmailCategoryStatesEndpointError, SaveOrganizationEmailCategoryStatesEndpointResponse, SaveRoleEmailCategoryStatesEndpointData, SaveRoleEmailCategoryStatesEndpointError, SaveRoleEmailCategoryStatesEndpointResponse, SaveUserEmailPreferencesEndpointData, SaveUserEmailPreferencesEndpointError, SaveUserEmailPreferencesEndpointResponse, SaveUserSettingsEndpointData, SaveUserSettingsEndpointResponse, SendSampleEmailEndpointData, SendSampleEmailEndpointError, SendSampleEmailEndpointResponse, SetUserLanguageEndpointData, SetUserLanguageEndpointResponse, UpdateOrganizationEndpointData, UpdateOrganizationEndpointResponse, UpdateRoleEndpointData, UpdateRoleEndpointResponse, UpdateTruckEndpointData, UpdateTruckEndpointResponse, UpdateUserEndpointData, UpdateUserEndpointError, UpdateUserEndpointResponse, UpdateWarehouseEndpointData, UpdateWarehouseEndpointResponse } from '../types.gen';

/**
 * Delete warehouse
 *
 * Deletes a warehouse by ID
 */
export const deleteWarehouseEndpointMutation = (options?: Partial<Options<DeleteWarehouseEndpointData>>): MutationOptions<DeleteWarehouseEndpointResponse, DefaultError, Options<DeleteWarehouseEndpointData>> => {
    const mutationOptions: MutationOptions<DeleteWarehouseEndpointResponse, DefaultError, Options<DeleteWarehouseEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWarehouseEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getWarehouseEndpointQueryKey = (options: Options<GetWarehouseEndpointData>) => createQueryKey('getWarehouseEndpoint', options);

/**
 * Get warehouse by ID
 *
 * Retrieves a specific warehouse by ID
 */
export const getWarehouseEndpointOptions = (options: Options<GetWarehouseEndpointData>) => queryOptions<GetWarehouseEndpointResponse, DefaultError, GetWarehouseEndpointResponse, ReturnType<typeof getWarehouseEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseEndpointQueryKey(options)
});

/**
 * Update a warehouse
 *
 * Update an existing warehouse
 */
export const updateWarehouseEndpointMutation = (options?: Partial<Options<UpdateWarehouseEndpointData>>): MutationOptions<UpdateWarehouseEndpointResponse, DefaultError, Options<UpdateWarehouseEndpointData>> => {
    const mutationOptions: MutationOptions<UpdateWarehouseEndpointResponse, DefaultError, Options<UpdateWarehouseEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWarehouseEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWarehousesEndpointQueryKey = (options?: Options<ListWarehousesEndpointData>) => createQueryKey('listWarehousesEndpoint', options);

/**
 * Get warehouses
 *
 * Retrieves a list of all warehouses
 */
export const listWarehousesEndpointOptions = (options?: Options<ListWarehousesEndpointData>) => queryOptions<ListWarehousesEndpointResponse, DefaultError, ListWarehousesEndpointResponse, ReturnType<typeof listWarehousesEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWarehousesEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehousesEndpointQueryKey(options)
});

/**
 * Create a warehouse
 *
 * Create a new warehouse
 */
export const createWarehouseEndpointMutation = (options?: Partial<Options<CreateWarehouseEndpointData>>): MutationOptions<CreateWarehouseEndpointResponse, DefaultError, Options<CreateWarehouseEndpointData>> => {
    const mutationOptions: MutationOptions<CreateWarehouseEndpointResponse, DefaultError, Options<CreateWarehouseEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWarehouseEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete truck
 *
 * Deletes a truck by ID
 */
export const deleteTruckEndpointMutation = (options?: Partial<Options<DeleteTruckEndpointData>>): MutationOptions<DeleteTruckEndpointResponse, DefaultError, Options<DeleteTruckEndpointData>> => {
    const mutationOptions: MutationOptions<DeleteTruckEndpointResponse, DefaultError, Options<DeleteTruckEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTruckEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTruckEndpointQueryKey = (options: Options<GetTruckEndpointData>) => createQueryKey('getTruckEndpoint', options);

/**
 * Get truck by ID
 *
 * Retrieves a specific truck by ID
 */
export const getTruckEndpointOptions = (options: Options<GetTruckEndpointData>) => queryOptions<GetTruckEndpointResponse, DefaultError, GetTruckEndpointResponse, ReturnType<typeof getTruckEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTruckEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTruckEndpointQueryKey(options)
});

/**
 * Update a truck
 *
 * Update an existing truck
 */
export const updateTruckEndpointMutation = (options?: Partial<Options<UpdateTruckEndpointData>>): MutationOptions<UpdateTruckEndpointResponse, DefaultError, Options<UpdateTruckEndpointData>> => {
    const mutationOptions: MutationOptions<UpdateTruckEndpointResponse, DefaultError, Options<UpdateTruckEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTruckEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTrucksEndpointQueryKey = (options?: Options<ListTrucksEndpointData>) => createQueryKey('listTrucksEndpoint', options);

/**
 * Get trucks
 *
 * Retrieves a list of all trucks
 */
export const listTrucksEndpointOptions = (options?: Options<ListTrucksEndpointData>) => queryOptions<ListTrucksEndpointResponse, DefaultError, ListTrucksEndpointResponse, ReturnType<typeof listTrucksEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTrucksEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTrucksEndpointQueryKey(options)
});

/**
 * Create a truck
 *
 * Create a new truck
 */
export const createTruckEndpointMutation = (options?: Partial<Options<CreateTruckEndpointData>>): MutationOptions<CreateTruckEndpointResponse, DefaultError, Options<CreateTruckEndpointData>> => {
    const mutationOptions: MutationOptions<CreateTruckEndpointResponse, DefaultError, Options<CreateTruckEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTruckEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * I18N Localization
 *
 * Example of I18N Service localization
 */
export const endpointMutation = (options?: Partial<Options<EndpointData>>): MutationOptions<EndpointResponse, DefaultError, Options<EndpointData>> => {
    const mutationOptions: MutationOptions<EndpointResponse, DefaultError, Options<EndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await endpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save user settings
 *
 * Updates or creates user setting overrides for the current user
 */
export const saveUserSettingsEndpointMutation = (options?: Partial<Options<SaveUserSettingsEndpointData>>): MutationOptions<SaveUserSettingsEndpointResponse, DefaultError, Options<SaveUserSettingsEndpointData>> => {
    const mutationOptions: MutationOptions<SaveUserSettingsEndpointResponse, DefaultError, Options<SaveUserSettingsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveUserSettingsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset user settings to defaults
 *
 * Deletes all user setting overrides for the current user, reverting to application defaults
 */
export const resetUserSettingsEndpointMutation = (options?: Partial<Options<ResetUserSettingsEndpointData>>): MutationOptions<ResetUserSettingsEndpointResponse, DefaultError, Options<ResetUserSettingsEndpointData>> => {
    const mutationOptions: MutationOptions<ResetUserSettingsEndpointResponse, DefaultError, Options<ResetUserSettingsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetUserSettingsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserSettingListEndpointQueryKey = (options?: Options<GetUserSettingListEndpointData>) => createQueryKey('getUserSettingListEndpoint', options);

/**
 * Get user-editable settings
 *
 * Returns all user-editable setting definitions with current user's customized values and defaults
 */
export const getUserSettingListEndpointOptions = (options?: Options<GetUserSettingListEndpointData>) => queryOptions<GetUserSettingListEndpointResponse, DefaultError, GetUserSettingListEndpointResponse, ReturnType<typeof getUserSettingListEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserSettingListEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserSettingListEndpointQueryKey(options)
});

/**
 * Save application settings
 *
 * Updates multiple application setting values (admin only)
 */
export const saveApplicationSettingsEndpointMutation = (options?: Partial<Options<SaveApplicationSettingsEndpointData>>): MutationOptions<SaveApplicationSettingsEndpointResponse, DefaultError, Options<SaveApplicationSettingsEndpointData>> => {
    const mutationOptions: MutationOptions<SaveApplicationSettingsEndpointResponse, DefaultError, Options<SaveApplicationSettingsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveApplicationSettingsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset application settings to defaults
 *
 * Deletes all application settings and re-seeds with default values (admin only)
 */
export const resetApplicationSettingsEndpointMutation = (options?: Partial<Options<ResetApplicationSettingsEndpointData>>): MutationOptions<ResetApplicationSettingsEndpointResponse, DefaultError, Options<ResetApplicationSettingsEndpointData>> => {
    const mutationOptions: MutationOptions<ResetApplicationSettingsEndpointResponse, DefaultError, Options<ResetApplicationSettingsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetApplicationSettingsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save grid settings for the current user
 *
 * Creates or updates grid settings for the provided key
 */
export const saveGridSettingsEndpointMutation = (options?: Partial<Options<SaveGridSettingsEndpointData>>): MutationOptions<SaveGridSettingsEndpointResponse, DefaultError, Options<SaveGridSettingsEndpointData>> => {
    const mutationOptions: MutationOptions<SaveGridSettingsEndpointResponse, DefaultError, Options<SaveGridSettingsEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveGridSettingsEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGridSettingsEndpointQueryKey = (options: Options<GetGridSettingsEndpointData>) => createQueryKey('getGridSettingsEndpoint', options);

/**
 * Get settings for provided grid key
 *
 * Returns grid settings for provided grid key
 */
export const getGridSettingsEndpointOptions = (options: Options<GetGridSettingsEndpointData>) => queryOptions<GetGridSettingsEndpointResponse, DefaultError, GetGridSettingsEndpointResponse, ReturnType<typeof getGridSettingsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGridSettingsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGridSettingsEndpointQueryKey(options)
});

export const getSettingsEndpointQueryKey = (options?: Options<GetSettingsEndpointData>) => createQueryKey('getSettingsEndpoint', options);

/**
 * Get effective runtime settings
 *
 * Returns merged application and user settings - user settings override application defaults
 */
export const getSettingsEndpointOptions = (options?: Options<GetSettingsEndpointData>) => queryOptions<GetSettingsEndpointResponse, DefaultError, GetSettingsEndpointResponse, ReturnType<typeof getSettingsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSettingsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSettingsEndpointQueryKey(options)
});

export const getLoginApplicationSettingsEndpointQueryKey = (options?: Options<GetLoginApplicationSettingsEndpointData>) => createQueryKey('getLoginApplicationSettingsEndpoint', options);

/**
 * Get login settings
 *
 * Returns application settings required for the login page (publicly accessible)
 */
export const getLoginApplicationSettingsEndpointOptions = (options?: Options<GetLoginApplicationSettingsEndpointData>) => queryOptions<GetLoginApplicationSettingsEndpointResponse, DefaultError, GetLoginApplicationSettingsEndpointResponse, ReturnType<typeof getLoginApplicationSettingsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLoginApplicationSettingsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLoginApplicationSettingsEndpointQueryKey(options)
});

export const getApplicationSettingListEndpointQueryKey = (options?: Options<GetApplicationSettingListEndpointData>) => createQueryKey('getApplicationSettingListEndpoint', options);

/**
 * Get all application settings
 *
 * Returns all application setting definitions with their current values for administrative management
 */
export const getApplicationSettingListEndpointOptions = (options?: Options<GetApplicationSettingListEndpointData>) => queryOptions<GetApplicationSettingListEndpointResponse, DefaultError, GetApplicationSettingListEndpointResponse, ReturnType<typeof getApplicationSettingListEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApplicationSettingListEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApplicationSettingListEndpointQueryKey(options)
});

/**
 * Plan an order
 *
 * Assigns a truck to an order, sets status to Planned, and creates an Instruction
 */
export const planOrderEndpointMutation = (options?: Partial<Options<PlanOrderEndpointData>>): MutationOptions<PlanOrderEndpointResponse, DefaultError, Options<PlanOrderEndpointData>> => {
    const mutationOptions: MutationOptions<PlanOrderEndpointResponse, DefaultError, Options<PlanOrderEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planOrderEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrdersEndpointQueryKey = (options?: Options<ListOrdersEndpointData>) => createQueryKey('listOrdersEndpoint', options);

/**
 * Get orders
 *
 * Retrieves a list of all orders
 */
export const listOrdersEndpointOptions = (options?: Options<ListOrdersEndpointData>) => queryOptions<ListOrdersEndpointResponse, DefaultError, ListOrdersEndpointResponse, ReturnType<typeof listOrdersEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrdersEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrdersEndpointQueryKey(options)
});

/**
 * Put an order on hold
 *
 * Sets an order status to On Hold with a remark
 */
export const holdOrderEndpointMutation = (options?: Partial<Options<HoldOrderEndpointData>>): MutationOptions<HoldOrderEndpointResponse, DefaultError, Options<HoldOrderEndpointData>> => {
    const mutationOptions: MutationOptions<HoldOrderEndpointResponse, DefaultError, Options<HoldOrderEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdOrderEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel an order
 *
 * Sets an order status to Cancelled with a remark
 */
export const cancelOrderEndpointMutation = (options?: Partial<Options<CancelOrderEndpointData>>): MutationOptions<CancelOrderEndpointResponse, DefaultError, Options<CancelOrderEndpointData>> => {
    const mutationOptions: MutationOptions<CancelOrderEndpointResponse, DefaultError, Options<CancelOrderEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelOrderEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInstructionsEndpointQueryKey = (options?: Options<ListInstructionsEndpointData>) => createQueryKey('listInstructionsEndpoint', options);

/**
 * Get instructions
 *
 * Retrieves a list of all instructions
 */
export const listInstructionsEndpointOptions = (options?: Options<ListInstructionsEndpointData>) => queryOptions<ListInstructionsEndpointResponse, DefaultError, ListInstructionsEndpointResponse, ReturnType<typeof listInstructionsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInstructionsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInstructionsEndpointQueryKey(options)
});

/**
 * Put an instruction on hold
 *
 * Sets an instruction status to On Hold with a remark
 */
export const holdInstructionEndpointMutation = (options?: Partial<Options<HoldInstructionEndpointData>>): MutationOptions<HoldInstructionEndpointResponse, DefaultError, Options<HoldInstructionEndpointData>> => {
    const mutationOptions: MutationOptions<HoldInstructionEndpointResponse, DefaultError, Options<HoldInstructionEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await holdInstructionEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel an instruction
 *
 * Sets an instruction status to Cancelled with a remark
 */
export const cancelInstructionEndpointMutation = (options?: Partial<Options<CancelInstructionEndpointData>>): MutationOptions<CancelInstructionEndpointResponse, DefaultError, Options<CancelInstructionEndpointData>> => {
    const mutationOptions: MutationOptions<CancelInstructionEndpointResponse, DefaultError, Options<CancelInstructionEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelInstructionEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign an instruction
 *
 * Updates truck and destination for an instruction and sets status to Assigned
 */
export const assignInstructionEndpointMutation = (options?: Partial<Options<AssignInstructionEndpointData>>): MutationOptions<AssignInstructionEndpointResponse, DefaultError, Options<AssignInstructionEndpointData>> => {
    const mutationOptions: MutationOptions<AssignInstructionEndpointResponse, DefaultError, Options<AssignInstructionEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignInstructionEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserEmailPreferencesEndpointQueryKey = (options?: Options<GetUserEmailPreferencesEndpointData>) => createQueryKey('getUserEmailPreferencesEndpoint', options);

/**
 * Get current user email category preferences
 *
 * Returns explicit user preference and effective availability per email category.
 */
export const getUserEmailPreferencesEndpointOptions = (options?: Options<GetUserEmailPreferencesEndpointData>) => queryOptions<GetUserEmailPreferencesEndpointResponse, DefaultError, GetUserEmailPreferencesEndpointResponse, ReturnType<typeof getUserEmailPreferencesEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserEmailPreferencesEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserEmailPreferencesEndpointQueryKey(options)
});

/**
 * Save current user email category preferences
 *
 * Upserts explicit user-level email category preferences.
 */
export const saveUserEmailPreferencesEndpointMutation = (options?: Partial<Options<SaveUserEmailPreferencesEndpointData>>): MutationOptions<SaveUserEmailPreferencesEndpointResponse, SaveUserEmailPreferencesEndpointError, Options<SaveUserEmailPreferencesEndpointData>> => {
    const mutationOptions: MutationOptions<SaveUserEmailPreferencesEndpointResponse, SaveUserEmailPreferencesEndpointError, Options<SaveUserEmailPreferencesEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveUserEmailPreferencesEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Queue sample email
 *
 * Enqueues a sample email into the Hangfire emails queue.
 */
export const sendSampleEmailEndpointMutation = (options?: Partial<Options<SendSampleEmailEndpointData>>): MutationOptions<SendSampleEmailEndpointResponse, SendSampleEmailEndpointError, Options<SendSampleEmailEndpointData>> => {
    const mutationOptions: MutationOptions<SendSampleEmailEndpointResponse, SendSampleEmailEndpointError, Options<SendSampleEmailEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendSampleEmailEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthEndpointQueryKey = (options?: Options<HealthEndpointData>) => createQueryKey('healthEndpoint', options);

/**
 * Liveness probe
 *
 * Returns immediately when the API process is running.
 */
export const healthEndpointOptions = (options?: Options<HealthEndpointData>) => queryOptions<HealthEndpointResponse, DefaultError, HealthEndpointResponse, ReturnType<typeof healthEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthEndpointQueryKey(options)
});

export const readinessEndpointQueryKey = (options?: Options<ReadinessEndpointData>) => createQueryKey('readinessEndpoint', options);

/**
 * Readiness probe
 *
 * Checks connectivity to critical dependencies.
 */
export const readinessEndpointOptions = (options?: Options<ReadinessEndpointData>) => queryOptions<ReadinessEndpointResponse, DefaultError, ReadinessEndpointResponse, ReturnType<typeof readinessEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readinessEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readinessEndpointQueryKey(options)
});

export const getCodelistsEndpointQueryKey = (options: Options<GetCodelistsEndpointData>) => createQueryKey('getCodelistsEndpoint', options);

/**
 * Query codelist entities
 *
 * Generic endpoint for querying codelist entities with filtering
 */
export const getCodelistsEndpointOptions = (options: Options<GetCodelistsEndpointData>) => queryOptions<GetCodelistsEndpointResponse, DefaultError, GetCodelistsEndpointResponse, ReturnType<typeof getCodelistsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCodelistsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCodelistsEndpointQueryKey(options)
});

export const addCodelistEndpointMutation = (options?: Partial<Options<AddCodelistEndpointData>>): MutationOptions<AddCodelistEndpointResponse, DefaultError, Options<AddCodelistEndpointData>> => {
    const mutationOptions: MutationOptions<AddCodelistEndpointResponse, DefaultError, Options<AddCodelistEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addCodelistEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change user language
 *
 * Change user language setting for logged in user
 */
export const setUserLanguageEndpointMutation = (options?: Partial<Options<SetUserLanguageEndpointData>>): MutationOptions<SetUserLanguageEndpointResponse, DefaultError, Options<SetUserLanguageEndpointData>> => {
    const mutationOptions: MutationOptions<SetUserLanguageEndpointResponse, DefaultError, Options<SetUserLanguageEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserLanguageEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logout user
 *
 * Sign out user and clear session cookie
 */
export const logoutEndpointMutation = (options?: Partial<Options<LogoutEndpointData>>): MutationOptions<LogoutEndpointResponse, DefaultError, Options<LogoutEndpointData>> => {
    const mutationOptions: MutationOptions<LogoutEndpointResponse, DefaultError, Options<LogoutEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login user
 *
 * Authenticate user and create session cookie
 */
export const loginEndpointMutation = (options?: Partial<Options<LoginEndpointData>>): MutationOptions<LoginEndpointResponse, LoginEndpointError, Options<LoginEndpointData>> => {
    const mutationOptions: MutationOptions<LoginEndpointResponse, LoginEndpointError, Options<LoginEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const isAuthenticatedEndpointQueryKey = (options?: Options<IsAuthenticatedEndpointData>) => createQueryKey('isAuthenticatedEndpoint', options);

/**
 * Checks if the request contains valid cookie
 */
export const isAuthenticatedEndpointOptions = (options?: Options<IsAuthenticatedEndpointData>) => queryOptions<IsAuthenticatedEndpointResponse, DefaultError, IsAuthenticatedEndpointResponse, ReturnType<typeof isAuthenticatedEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await isAuthenticatedEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: isAuthenticatedEndpointQueryKey(options)
});

export const getCurrentUserEndpointQueryKey = (options?: Options<GetCurrentUserEndpointData>) => createQueryKey('getCurrentUserEndpoint', options);

/**
 * Get logged in user
 *
 * Used for cookie-based authentication on the frontend
 */
export const getCurrentUserEndpointOptions = (options?: Options<GetCurrentUserEndpointData>) => queryOptions<GetCurrentUserEndpointResponse, DefaultError, GetCurrentUserEndpointResponse, ReturnType<typeof getCurrentUserEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentUserEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentUserEndpointQueryKey(options)
});

/**
 * Delete user
 *
 * Deletes a user by their ID
 */
export const deleteUserEndpointMutation = (options?: Partial<Options<DeleteUserEndpointData>>): MutationOptions<DeleteUserEndpointResponse, DefaultError, Options<DeleteUserEndpointData>> => {
    const mutationOptions: MutationOptions<DeleteUserEndpointResponse, DefaultError, Options<DeleteUserEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserEndpointQueryKey = (options: Options<GetUserEndpointData>) => createQueryKey('getUserEndpoint', options);

/**
 * Get user by ID
 *
 * Retrieves a specific user by their ID
 */
export const getUserEndpointOptions = (options: Options<GetUserEndpointData>) => queryOptions<GetUserEndpointResponse, DefaultError, GetUserEndpointResponse, ReturnType<typeof getUserEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserEndpointQueryKey(options)
});

/**
 * Update user
 *
 * Updates an existing user's information
 */
export const updateUserEndpointMutation = (options?: Partial<Options<UpdateUserEndpointData>>): MutationOptions<UpdateUserEndpointResponse, UpdateUserEndpointError, Options<UpdateUserEndpointData>> => {
    const mutationOptions: MutationOptions<UpdateUserEndpointResponse, UpdateUserEndpointError, Options<UpdateUserEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUserEndpointQueryKey = (options: Options<ListUserEndpointData>) => createQueryKey('listUserEndpoint', options);

/**
 * Get users
 *
 * Retrieves a list of users
 */
export const listUserEndpointOptions = (options: Options<ListUserEndpointData>) => queryOptions<ListUserEndpointResponse, DefaultError, ListUserEndpointResponse, ReturnType<typeof listUserEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUserEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUserEndpointQueryKey(options)
});

/**
 * Create a new user
 *
 * Creates a new user and returns the created user data
 */
export const createUserEndpointMutation = (options?: Partial<Options<CreateUserEndpointData>>): MutationOptions<CreateUserEndpointResponse, CreateUserEndpointError, Options<CreateUserEndpointData>> => {
    const mutationOptions: MutationOptions<CreateUserEndpointResponse, CreateUserEndpointError, Options<CreateUserEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUserEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRoleEndpointQueryKey = (options: Options<GetRoleEndpointData>) => createQueryKey('getRoleEndpoint', options);

/**
 * Get role by ID
 *
 * Retrieves a specific role by ID
 */
export const getRoleEndpointOptions = (options: Options<GetRoleEndpointData>) => queryOptions<GetRoleEndpointResponse, DefaultError, GetRoleEndpointResponse, ReturnType<typeof getRoleEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRoleEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRoleEndpointQueryKey(options)
});

/**
 * Update a role
 *
 * Update an existing role
 */
export const updateRoleEndpointMutation = (options?: Partial<Options<UpdateRoleEndpointData>>): MutationOptions<UpdateRoleEndpointResponse, DefaultError, Options<UpdateRoleEndpointData>> => {
    const mutationOptions: MutationOptions<UpdateRoleEndpointResponse, DefaultError, Options<UpdateRoleEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRoleEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRolesEndpointQueryKey = (options: Options<ListRolesEndpointData>) => createQueryKey('listRolesEndpoint', options);

/**
 * Get roles
 *
 * Retrieves a list of roles
 */
export const listRolesEndpointOptions = (options: Options<ListRolesEndpointData>) => queryOptions<ListRolesEndpointResponse, DefaultError, ListRolesEndpointResponse, ReturnType<typeof listRolesEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRolesEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRolesEndpointQueryKey(options)
});

/**
 * Create a role
 *
 * Create a new role
 */
export const createRoleEndpointMutation = (options?: Partial<Options<CreateRoleEndpointData>>): MutationOptions<CreateRoleEndpointResponse, DefaultError, Options<CreateRoleEndpointData>> => {
    const mutationOptions: MutationOptions<CreateRoleEndpointResponse, DefaultError, Options<CreateRoleEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRoleEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const roleCodelistEndpointQueryKey = (options: Options<RoleCodelistEndpointData>) => createQueryKey('roleCodelistEndpoint', options);

/**
 * Query codelist entities
 *
 * Generic endpoint for querying codelist entities with filtering
 */
export const roleCodelistEndpointOptions = (options: Options<RoleCodelistEndpointData>) => queryOptions<RoleCodelistEndpointResponse, DefaultError, RoleCodelistEndpointResponse, ReturnType<typeof roleCodelistEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await roleCodelistEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: roleCodelistEndpointQueryKey(options)
});

export const listPermissionsEndpointQueryKey = (options: Options<ListPermissionsEndpointData>) => createQueryKey('listPermissionsEndpoint', options);

/**
 * Get permissions
 *
 * Retrieves a list of permissions
 */
export const listPermissionsEndpointOptions = (options: Options<ListPermissionsEndpointData>) => queryOptions<ListPermissionsEndpointResponse, DefaultError, ListPermissionsEndpointResponse, ReturnType<typeof listPermissionsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPermissionsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPermissionsEndpointQueryKey(options)
});

export const permissionCodelistEndpointQueryKey = (options: Options<PermissionCodelistEndpointData>) => createQueryKey('permissionCodelistEndpoint', options);

/**
 * Query permission codelist entities
 *
 * Endpoint for querying permission codelist entities with filtering
 */
export const permissionCodelistEndpointOptions = (options: Options<PermissionCodelistEndpointData>) => queryOptions<PermissionCodelistEndpointResponse, DefaultError, PermissionCodelistEndpointResponse, ReturnType<typeof permissionCodelistEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await permissionCodelistEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: permissionCodelistEndpointQueryKey(options)
});

export const getOrganizationEndpointQueryKey = (options: Options<GetOrganizationEndpointData>) => createQueryKey('getOrganizationEndpoint', options);

/**
 * Get organization by ID
 *
 * Retrieves a specific organization by ID
 */
export const getOrganizationEndpointOptions = (options: Options<GetOrganizationEndpointData>) => queryOptions<GetOrganizationEndpointResponse, DefaultError, GetOrganizationEndpointResponse, ReturnType<typeof getOrganizationEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationEndpointQueryKey(options)
});

/**
 * Update an organization
 *
 * Update an existing organization
 */
export const updateOrganizationEndpointMutation = (options?: Partial<Options<UpdateOrganizationEndpointData>>): MutationOptions<UpdateOrganizationEndpointResponse, DefaultError, Options<UpdateOrganizationEndpointData>> => {
    const mutationOptions: MutationOptions<UpdateOrganizationEndpointResponse, DefaultError, Options<UpdateOrganizationEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganizationEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationsEndpointQueryKey = (options: Options<ListOrganizationsEndpointData>) => createQueryKey('listOrganizationsEndpoint', options);

/**
 * Get organizations
 *
 * Retrieves a list of organizations
 */
export const listOrganizationsEndpointOptions = (options: Options<ListOrganizationsEndpointData>) => queryOptions<ListOrganizationsEndpointResponse, DefaultError, ListOrganizationsEndpointResponse, ReturnType<typeof listOrganizationsEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationsEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsEndpointQueryKey(options)
});

/**
 * Create an organization
 *
 * Create a new organization
 */
export const createOrganizationEndpointMutation = (options?: Partial<Options<CreateOrganizationEndpointData>>): MutationOptions<CreateOrganizationEndpointResponse, DefaultError, Options<CreateOrganizationEndpointData>> => {
    const mutationOptions: MutationOptions<CreateOrganizationEndpointResponse, DefaultError, Options<CreateOrganizationEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganizationEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationCodelistEndpointQueryKey = (options: Options<OrganizationCodelistEndpointData>) => createQueryKey('organizationCodelistEndpoint', options);

/**
 * Query organization codelist entities
 *
 * Endpoint for querying organization codelist entities with filtering
 */
export const organizationCodelistEndpointOptions = (options: Options<OrganizationCodelistEndpointData>) => queryOptions<OrganizationCodelistEndpointResponse, DefaultError, OrganizationCodelistEndpointResponse, ReturnType<typeof organizationCodelistEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationCodelistEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationCodelistEndpointQueryKey(options)
});

export const getRoleEmailCategoryStatesEndpointQueryKey = (options: Options<GetRoleEmailCategoryStatesEndpointData>) => createQueryKey('getRoleEmailCategoryStatesEndpoint', options);

/**
 * Get role email category states
 *
 * Returns all email categories and explicit role state overrides.
 */
export const getRoleEmailCategoryStatesEndpointOptions = (options: Options<GetRoleEmailCategoryStatesEndpointData>) => queryOptions<GetRoleEmailCategoryStatesEndpointResponse, DefaultError, GetRoleEmailCategoryStatesEndpointResponse, ReturnType<typeof getRoleEmailCategoryStatesEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRoleEmailCategoryStatesEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRoleEmailCategoryStatesEndpointQueryKey(options)
});

/**
 * Save role email category states
 *
 * Upserts explicit role-level email category overrides.
 */
export const saveRoleEmailCategoryStatesEndpointMutation = (options?: Partial<Options<SaveRoleEmailCategoryStatesEndpointData>>): MutationOptions<SaveRoleEmailCategoryStatesEndpointResponse, SaveRoleEmailCategoryStatesEndpointError, Options<SaveRoleEmailCategoryStatesEndpointData>> => {
    const mutationOptions: MutationOptions<SaveRoleEmailCategoryStatesEndpointResponse, SaveRoleEmailCategoryStatesEndpointError, Options<SaveRoleEmailCategoryStatesEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveRoleEmailCategoryStatesEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationEmailCategoryStatesEndpointQueryKey = (options: Options<GetOrganizationEmailCategoryStatesEndpointData>) => createQueryKey('getOrganizationEmailCategoryStatesEndpoint', options);

/**
 * Get organization email category states
 *
 * Returns all email categories and explicit organization state overrides.
 */
export const getOrganizationEmailCategoryStatesEndpointOptions = (options: Options<GetOrganizationEmailCategoryStatesEndpointData>) => queryOptions<GetOrganizationEmailCategoryStatesEndpointResponse, DefaultError, GetOrganizationEmailCategoryStatesEndpointResponse, ReturnType<typeof getOrganizationEmailCategoryStatesEndpointQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationEmailCategoryStatesEndpoint({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationEmailCategoryStatesEndpointQueryKey(options)
});

/**
 * Save organization email category states
 *
 * Upserts explicit organization-level email category overrides.
 */
export const saveOrganizationEmailCategoryStatesEndpointMutation = (options?: Partial<Options<SaveOrganizationEmailCategoryStatesEndpointData>>): MutationOptions<SaveOrganizationEmailCategoryStatesEndpointResponse, SaveOrganizationEmailCategoryStatesEndpointError, Options<SaveOrganizationEmailCategoryStatesEndpointData>> => {
    const mutationOptions: MutationOptions<SaveOrganizationEmailCategoryStatesEndpointResponse, SaveOrganizationEmailCategoryStatesEndpointError, Options<SaveOrganizationEmailCategoryStatesEndpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveOrganizationEmailCategoryStatesEndpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
